var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_vm._l((_vm.text),function(item,index){return _c('div',{key:index,style:(_vm.color)},[_c('div',{staticClass:"bottom"},[_vm._v(" "+_vm._s(item)+" ")])])}),_c('div',{staticClass:"bottomx",style:(_vm.color)},[_vm._v(" "+_vm._s(_vm.texts)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }